// extracted by mini-css-extract-plugin
export default {"container":"TrendsListChart_container__4dQXN","title":"TrendsListChart_title__akVFz","chart":"TrendsListChart_chart__Y0q24"};